import { createContext } from "react";

export const ChatWindowContext = createContext<HTMLElement | null>(null);
